import { render, staticRenderFns } from "./SelectedItem.vue?vue&type=template&id=0d080ec3&scoped=true"
import script from "./SelectedItem.vue?vue&type=script&lang=js"
export * from "./SelectedItem.vue?vue&type=script&lang=js"
import style0 from "./SelectedItem.vue?vue&type=style&index=0&id=0d080ec3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d080ec3",
  null
  
)

export default component.exports